<template>
  <span
    class="default-dropdown-option"
    data-sb-regression="sb-dropdown-option"
  >
    <!-- @slot slot to render dropdown option text -->
    <slot />
  </span>
</template>

<script>

/**
 * Helper component to be used as a slot inside dropdowns.
 */
export default {
  name: 'SbDropdownOption',
};
</script>

<style lang="scss">
@import '@src/components/Dropdown/style/sb-dropdown-option.scss';
</style>
